import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items = [] }) {
  return <div className="breadcrumbs"><Link to="/admin">Overview</Link>{items.map((item) => <React.Fragment key={item.label}><span>/</span>{item.to ? <Link to={item.to}>{item.label}</Link> : <strong>{item.label}</strong>}</React.Fragment>)}</div>;
}